import { render } from "./TableHistoricCategory.vue?vue&type=template&id=6f03d673&scoped=true"
import script from "./TableHistoricCategory.vue?vue&type=script&lang=js"
export * from "./TableHistoricCategory.vue?vue&type=script&lang=js"

import "./TableHistoricCategory.vue?vue&type=style&index=0&id=6f03d673&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f03d673"]])

export default __exports__